<template>
    <div class="columns is-multiline document-container is-mobile">
        <div class="column is-narrow">
            <i class="fal has-text-primary fa-file-signature is-size-4 pt-2 pb-2 pl-4"></i>
        </div>
        <div class="column">
            <h5 class="pt-2 mb-1">{{document.subject}}</h5>
            <div class="">
                <div class="mb-4" v-if="document.id_number">{{document.id_number}}</div>
            </div>
            <div class="mt-3">
                <div class="notes mb-4" v-if="document.information">{{document.information}}</div>
            </div>
            <b-tag type="is-light" size="is-small" v-if="mine"><i class="fas fa-user fa-fw mr-2"></i>Added by you</b-tag>
        </div>
        <div class="column is-offset-1-desktop is-narrow">
            <div class="buttons is-right">
                <!-- Only when a file is actually attached — an entry can be just a
                     reference number, as on the account Documents page. -->
                <b-button v-if="document.file" type="is-primary" size="is-small" outlined @click="$emit('download', document)">
                    <i class="fad fa-file-download mr-2"></i> Download/View
                </b-button>
                <!-- Documents staff attached are read-only here; travellers manage
                     only what they uploaded themselves. -->
                <template v-if="mine">
                    <b-button type="is-info" size="is-small" outlined @click="$emit('edit', document)"><i class="fas fa-pen mr-2"></i>Edit</b-button>
                    <b-button type="is-danger" size="is-small" outlined @click="$emit('delete', document)"><i class="fas fa-trash mr-2"></i>Delete</b-button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'RegistrationDocument',
        props: {
            document: {
                type: Object,
                required: true
            }
        },
        computed: {
            mine: function() {
                return !!Number(this.document.is_traveller_upload);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .document-container {
        margin: 0.05px 0.05px 1rem;
        background-color: white;
        border-radius: 0.3rem;
        position: relative;
        padding: 0.05px;

        @media only screen and (max-width: 768px) {
            h4 {
                font-size: 1rem;
            }
        }

        .notes {
            border: 1px solid #eee;
            border-radius: 8px;
            padding: 0.5rem;
            font-size: 0.9rem;
            margin-left: -8px;
        }
    }
</style>
